// libs
import { useDispatch, useSelector } from "react-redux";
import {
  addAction as addActionAction,
  delAction as delActionAction,
  setActions as setActionsAction,
} from "../store/slices/actions.slice.js";

export default function useActions() {
  const { actions } = useSelector((s) => s.actionsSlice);
  const dispatch = useDispatch();

  const newAction = (newAction) => {
    dispatch(addActionAction(newAction));
  };

  const delAction = (id) => {
    dispatch(delActionAction(id));
  };

  const setActions = (newActions) => {
    dispatch(setActionsAction(newActions));
  };

  return { actions, newAction, delAction, setActions };
}
